import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/Addons.js';
import { Pane } from 'tweakpane'
import Grass from './Grass';
import Terrain from './Terrain';
import Stats from 'three/examples/jsm/libs/stats.module.js';



class World {
  clock = new THREE.Clock();
  stats = new Stats();
  textureLoader = new THREE.TextureLoader();
  sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
    pixelRatio: Math.min(window.devicePixelRatio, 2)
  }

  debugObj = {
    // colorOne: '#455B0A',
    colorOne: '#6c4507',
    colorTwo: '#847e06',
    sideLength: 70,
    heightScale: 3.5,
    lightIntensity: 2.5,
  }


  constructor() {
    document.body.appendChild(this.stats.dom);

    this._init();    
    this._animate();
    this._initDebug();

    addEventListener('resize', () => this._onResize());
  }

  _init () {
    this.canvas = document.querySelector('canvas.webgl');
    this.scene = new THREE.Scene();
    this.camera = new THREE.PerspectiveCamera(75, this.sizes.width / this.sizes.height, 0.01, 10000);
    
    this.camera.position.y = 4.5;
    this.camera.position.z = 25;

    this.scene.add(this.camera);

    this.controls = new OrbitControls(this.camera, this.canvas);
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.05;
    // this.controls.minPolarAngle = Math.PI * 0.35;
    this.controls.maxPolarAngle = Math.PI * 0.45;
    this.controls.enablePan = false;
    // this.controls.enableZoom = false;

    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
    });
    this.renderer.setClearColor(0x20272F, 1);
    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(this.sizes.pixelRatio);

    this.textureLoader.load('env.png', (texture) => {
      texture.mapping = THREE.EquirectangularReflectionMapping;
      texture.colorSpace = THREE.SRGBColorSpace;
  
      this.scene.environment = texture;
      this.scene.background = texture;
  });
  


    this.grassMesh = new Grass(this.debugObj);
    this.scene.add(this.grassMesh.init());


    this.terrain = new Terrain(this.debugObj);
    this.scene.add(this.terrain._init());

 
  }

  _initDebug() {

    const pane = new Pane();

    
    const global = pane.addFolder({ title: 'Debugger', expanded: false });

    // global.addBinding(this.debugObj, 'sideLength', { max: 100, min: 10, step: 1 }).on('change', (e) => {
    //   this.grassMesh.updateGrassGeometry(e.value, 0.15);
    //   this.terrain.mesh.scale.set(e.value /100, e.value/100, 1);
    // })

    global.addBinding(this.debugObj, 'heightScale', { max: 5.0, min: 0.5, steo: 0.1 })
    .on('change', (e) => {
      this.grassMesh.material.uniforms.uHeightScale.value = e.value;
      this.terrain.material.uniforms.uHeightScale.value = e.value;
    });

    global.addBinding(this.debugObj, 'lightIntensity', { max: 10.0, min: 1.0, steo: 0.1 }).on('change', (e) => {
      this.grassMesh.material.uniforms.uLightIntensity.value = e.value;
      this.terrain.material.uniforms.uLightIntensity.value = e.value;
    });

    global.addBinding(this.debugObj, 'colorOne').on('change', (e) => {
      this.grassMesh.material.uniforms.uColorOne.value.set(e.value);
      this.terrain.material.uniforms.uColorOne.value.set(e.value);
    });

    global.addBinding(this.debugObj, 'colorTwo').on('change', (e) => {
      this.grassMesh.material.uniforms.uColorTwo.value.set(e.value);
      this.terrain.material.uniforms.uColorTwo.value.set(e.value);
    });

  }

  _onResize() {
    this.sizes.width = window.innerWidth;
    this.sizes.height = window.innerHeight;
    this.sizes.pixelRatio = Math.min(window.devicePixelRatio, 2);

    this.camera.aspect = this.sizes.width / this.sizes.height;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(this.sizes.pixelRatio);
  }

  _animate() {
    this.stats.begin();
    
    requestAnimationFrame(() => this._animate());
    const elapsedTime = this.clock.getElapsedTime();
    
    this.grassMesh.update(elapsedTime, this.camera.position);
    // this.cubeMesh.update();
    
    this.controls.update();
    this.renderer.render(this.scene, this.camera);
    this.stats.end();
  }

}

export default World;